import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const isBlockingLoadingSelector = createSelector(
  (state: RootState) => state.ui.blockingAction,
  (count) => count > 0,
);
